import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between mb-2" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "text-h6 font-weight-bold" }
const _hoisted_4 = { class: "text-body-2 mb-2" }
const _hoisted_5 = { class: "d-flex align-center mb-2" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-center mb-2"
}
const _hoisted_7 = { class: "text-truncate" }
const _hoisted_8 = { class: "d-flex align-center mb-2" }
const _hoisted_9 = { class: "d-flex align-center mb-2" }
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-center mb-2"
}

import UniversalList, {PaginationOptions} from "@/components/misc/UniversalList.vue";
import {openOrderInformationDialog, t, useGlobalSetting} from "@/lib/utils";
import {reactive, ref} from "vue";
import {Groups, Order, StateColor} from "@/types/Order";
import {AssetFetchParams, AssetItem} from "@/types/Asset";
import {SortItem} from "vuetify/lib/components/VDataTable/composables/sort";
import {Header} from "@/lib/types";
import StateSelect from "@/components/inputs/StateSelect.vue";
import {getCompressedOrders, getOrdersFiltered} from "@/api/orders";
import {getCompressedTasks} from "@/api/tasks";

interface Props {
  defaultFilters?: Record<string, any>
  pageTitle?: string
  icon?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderListAll',
  props: {
    defaultFilters: { default: () => ({}) },
    pageTitle: { default: 'Aufträge' },
    icon: {}
  },
  setup(__props: any) {

const globalSettings = useGlobalSetting();

let orders = reactive<Order[]>([]);

const props = __props

const searchTerms = ref({
  ...props.defaultFilters
});

const options = ref<PaginationOptions>({page: 1, itemsPerPage: 5});
const totalItems = ref(0);
const pages = ref(0);
const sortBy = ref<SortItem[]>([{key: '', order: 'asc'}]);

const titleList = ref<AssetItem[]>();

const displayHeader: Header[] = [
  {title: "Auftragsnummer", key: "id", align: "center", icon: "mdi-numeric"},
  {title: "Title", key: "title", align: "center", icon: "mdi-format-title"},
  {title: "Author", key: "author", align: "center", icon: "mdi-account"},
  {title: "Anlage", key: "asset_id", align: "center", icon: "mdi-factory"},
  {title: "Dauer", key: "scheduled_duration", align: "center", icon: "mdi-clock-time-eight"},
  {title: "SollStart", key: "scheduled_start", align: "center", icon: "mdi-calendar-range"}
]

const headers: Header[] = [
  {title: 'Auftragsnummer', key: 'id', sortable: true, icon: 'mdi-identifier', align: 'center'},
  {title: 'Titel', key: 'title', sortable: true, icon: 'mdi-format-title', align: 'center'},
  {title: 'Autor', key: 'author', sortable: true, icon: 'mdi-account', align: 'center'},
  {
    title: 'Status',
    key: 'state',
    sortable: true,
    icon: 'mdi-checkbox-marked-circle-outline',
    align: 'center',
    filterComponent: StateSelect,
    filterProps: {permission: Groups.admin.permission}
  },
  {title: 'Beschreibung', key: 'description', sortable: false, icon: 'mdi-text-long', align: 'center'},
  {title: 'Anlage', key: 'asset_id', sortable: true, icon: 'mdi-factory', align: 'center'},
  {title: 'Dauer', key: 'scheduled_duration', sortable: true, icon: 'mdi-timer-outline', align: 'center'},
  {title: 'SollStart', key: 'scheduled_start', sortable: true, icon: 'mdi-calendar-start', align: 'center'},
  {title: 'SollEnde', key: 'scheduled_end', sortable: true, icon: 'mdi-calendar-end', align: 'center'},
  {title: 'Stillstandcode', key: 'outage_code', sortable: true, icon: 'mdi-pause-circle-outline', align: 'center'}
]

headers.forEach(header => {
  if (header.key in searchTerms.value) {
    header.disabled = true;
  }
})

displayHeader.forEach(header => {
  if (header.key in searchTerms.value) {
    header.disabled = true;
  }
})

const fetchData = async () => {
  globalSettings.loadingMessage = t("loading.getAuftragsListeData");
  globalSettings.isLoading = true;
  const {page, itemsPerPage} = options.value;
  const params = {
    page,
    itemsPerPage,
    sortBy: sortBy.value?.[0]?.key || "id",
    sortOrder: sortBy.value?.[0]?.order === "desc" ? "DESC" : "ASC",
    filters: searchTerms.value
  };

//apiClient.get("/getAuftragsListeData", {params});
  const response = await getOrdersFiltered(params)
  orders.length = 0;
  Object.assign(orders, response.items);
  orders.forEach(order => {
    order.id = Number(order.id);
  })
  totalItems.value = response.total;
  pages.value = Math.ceil(totalItems.value / options.value.itemsPerPage);
  globalSettings.isLoading = false;
  /*getAuftragsTitleList().then(data => {
    titleList.value = data.map(asset => {
          return {
            title: `${asset.title}`,
            subtitle: asset.id,
          }
        }
    );
    globalSettings.isLoading = false;
  });*/
};

const assetFetcher = (params: AssetFetchParams) => getCompressedOrders(params, props.defaultFilters);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(UniversalList, {
    "pagination-options": options.value,
    "onUpdate:paginationOptions": _cache[0] || (_cache[0] = ($event: any) => ((options).value = $event)),
    "search-term": searchTerms.value,
    "onUpdate:searchTerm": _cache[1] || (_cache[1] = ($event: any) => ((searchTerms).value = $event)),
    "sort-options": sortBy.value,
    "onUpdate:sortOptions": _cache[2] || (_cache[2] = ($event: any) => ((sortBy).value = $event)),
    title: _ctx.pageTitle,
    headers: headers,
    "display-header": displayHeader,
    "fetch-data": fetchData,
    "asset-fetcher": assetFetcher,
    list: _unref(orders),
    "total-items": totalItems.value,
    "asset-key": "id"
  }, _createSlots({
    "item.id": _withCtx(({item}) => [
      _createVNode(_component_v_chip, {
        text: item.id,
        border: "thin opacity-25",
        class: "hover_color_pro-hellblau",
        label: "",
        "prepend-icon": "mdi-book",
        onClick: ($event: any) => (_unref(openOrderInformationDialog)(item.id))
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_v_icon, { color: "medium-emphasis" })
        ]),
        _: 2
      }, 1032, ["text", "onClick"])
    ]),
    _: 2
  }, [
    (_unref(globalSettings).isMobile)
      ? {
          name: "body",
          fn: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orders), (item) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                key: item.id,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, {
                    class: "pa-3",
                    elevation: "1",
                    rounded: "lg"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-clipboard-text",
                            class: "me-2",
                            size: "20"
                          }),
                          _createElementVNode("span", _hoisted_3, "Auftrag #" + _toDisplayString(item.id), 1)
                        ]),
                        _createVNode(_component_v_chip, {
                          color: _unref(StateColor)[item.state],
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.state), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ]),
                      _createVNode(_component_v_divider, { class: "my-2" }),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-text",
                            class: "me-3",
                            size: "18",
                            color: "grey-darken-1"
                          }),
                          _createElementVNode("span", null, _toDisplayString(item.title), 1)
                        ]),
                        (item.description)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-comment-text",
                                class: "me-3",
                                size: "18",
                                color: "grey-darken-1"
                              }),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(item.description), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-clock",
                            class: "me-3",
                            size: "18",
                            color: "grey-darken-1"
                          }),
                          _createElementVNode("span", null, _toDisplayString(item.scheduled_duration), 1)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-factory",
                            class: "me-3",
                            size: "18",
                            color: "grey-darken-1"
                          }),
                          _createElementVNode("span", null, _toDisplayString(item.asset_id), 1)
                        ]),
                        (item.scheduled_start)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-calendar-clock",
                                class: "me-3",
                                size: "18",
                                color: "grey-darken-1"
                              }),
                              _createElementVNode("span", null, _toDisplayString(new Date(item.scheduled_start).toLocaleDateString()) + " " + _toDisplayString(new Date(item.scheduled_start).toLocaleTimeString([], {
                    hour: '2-digit',
                    minute: '2-digit'
                  })) + " Uhr", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_v_btn, {
                        block: "",
                        "prepend-icon": "mdi-eye",
                        variant: _unref(globalSettings).globalButtonVariant,
                        color: "btnColor",
                        size: "small",
                        onClick: ($event: any) => (_unref(openOrderInformationDialog)(item.id))
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode(" Details anzeigen ")
                        ])),
                        _: 2,
                        __: [3]
                      }, 1032, ["variant", "onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["pagination-options", "search-term", "sort-options", "title", "list", "total-items"]))
}
}

})